import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import { ButtonWithIcon } from '@els/els-react--button';
import FactsContext from '@Components/Results/substances/contexts/facts.context';
import NumberFormatter from '@Utils/NumberFormatter';
import { getFactCount } from '@Components/Results/substances/utils/factCountHelper';
import ResultHitNavigation from '@Components/Results/common/ResultHitNavigation';

import './SubstanceFactLinks.scss';

function SubstanceFactLinks({ substance, onToggle }) {
  const { facts } = useContext(FactsContext);
  const ariaLabel = 'Substance result details';

  if (isEmpty(facts)) {
    return null;
  }

  return (
    // RX-23573: not a `nav` landmark. Rendered once per result row, so a landmark here multiplied
    // into dozens of identical "Substance data categories" navigation landmarks — landmark overuse
    // (ARIA APG). The category toggles remain reachable in normal reading order.
    <ResultHitNavigation ariaLabel={ariaLabel}>
      <ul className="substance-fact-links">
        {map(facts, (fact) => {
          const isOpen = !!fact.open;
          const count = getFactCount(fact, substance);
          const factLabel = fact.count ? `${fact.title} - ${count}` : fact.title;
          const factId = factLabel.toLowerCase().replace(/[^a-z0-9]+/g, '-');

          return (
            <li className={classnames('substance-fact-links__item', { 'substance-fact-links__item--active': isOpen })} key={fact.title}>
              <ButtonWithIcon
                data-e2e={factId}
                className="substance-fact-links__accordion"
                type="link"
                size="small"
                iconRight
                linkIconSize="xs"
                sprite={isOpen ? 'ChevronUp' : 'ChevronDown'}
                aria-expanded={isOpen}
                onClick={(e) => {
                  e.preventDefault();
                  onToggle(fact.id);
                }}>
                {fact.title} {fact.count ? <span>- {NumberFormatter(getFactCount(fact, substance), 0)}</span> : null}
              </ButtonWithIcon>
            </li>
          );
        })}
      </ul>
    </ResultHitNavigation>
  );
}

SubstanceFactLinks.propTypes = {
  substance: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default SubstanceFactLinks;
